import { OPTION_ITEM_CONFIG } from '@/modules/corporate/modules/questions/fields/components/Player/OptionsListItem/consts';
import { OptionsListItemTypeEnum } from '@/modules/corporate/modules/questions/fields/single-select/types';

import { MTF_RIGHT_OPTION_ITEM_CONFIG } from '../../../consts';

export const getRightElementConfig = (type: OptionsListItemTypeEnum) => {
  const { classes, ...restConfig } = OPTION_ITEM_CONFIG[type];
  const { classes: overrideClasses, ...restOverrrideConfig } = MTF_RIGHT_OPTION_ITEM_CONFIG[type];

  return {
    ...restConfig,
    ...restOverrrideConfig,
    classes: {
      ...classes,
      ...overrideClasses,
    },
  };
};
